import * as consts from 'consts/consts';

import React, { FC, ReactNode } from 'react';
import { useIntl } from 'react-intl';
import {
  useIsAIAdmin,
  useIsSuperAdminNonImpersonating,
} from 'utils/models/User';
import { useFeatures } from 'utils/util/features';
import OrganizationAudit, {
  AuditEntryType,
} from 'views/Administration/PeopleAdministration/Audit/OrganizationAudit';
import { DocumentsAdminPage } from 'views/AI/Agents/DocumentsAdmin';
import { SkillsAdminPage } from 'views/AI/Agents/SkillsAdmin';
import { WorkflowsAdminPage } from 'views/AI/Agents/WorkflowsAdmin';
import Page from 'views/Layout/Pages/Page';
import AgentsAdminPage from './AgentsAdmin/AgentsAdminPage';
import { AIAgentsHubProvider } from './AiAgentsHubContext';

const AIAgentsHub: FC = () => {
  const { formatMessage } = useIntl();
  const { isGroupAndOptionEnabled } = useFeatures();
  const isAIAdmin = useIsAIAdmin();
  const isSuperAdmin = useIsSuperAdminNonImpersonating();
  const isAIAdminOrSuperAdmin = isAIAdmin || isSuperAdmin;

  const [action, setAction] = React.useState<ReactNode>(null);
  const tabs: {
    path: string;
    hasSubpaths?: boolean;
    paths?: string[];
    name: string;
    content: ReactNode;
  }[] = [];

  if (
    isGroupAndOptionEnabled('ai_assistant', 'ai_agents') &&
    isAIAdminOrSuperAdmin
  ) {
    tabs.push({
      path: consts.AI(formatMessage).path,
      paths: [
        consts.AI(formatMessage).path,
        consts.AI_AGENTS(formatMessage).path,
      ],
      name: consts.AI_AGENTS(formatMessage).name,
      content: <AgentsAdminPage />,
    });
    tabs.push({
      path: consts.AI_DOCUMENTS(formatMessage).path,
      name: consts.AI_DOCUMENTS(formatMessage).name,
      content: <DocumentsAdminPage />,
    });
    tabs.push({
      path: consts.AI_SKILLS(formatMessage).path,
      name: consts.AI_SKILLS(formatMessage).name,
      content: <SkillsAdminPage />,
    });
    tabs.push({
      path: consts.AI_WORKFLOWS(formatMessage).path,
      name: consts.AI_WORKFLOWS(formatMessage).name,
      content: <WorkflowsAdminPage />,
    });
    tabs.push({
      path: consts.AI_AUDIT(formatMessage).path,
      name: consts.AI_AUDIT(formatMessage).name,
      content: (
        <OrganizationAudit auditEntryTypes={[AuditEntryType.AI_MANAGEMENT]} />
      ),
    });
  }

  return (
    <AIAgentsHubProvider action={action} setAction={setAction}>
      <Page
        title={consts.AI(formatMessage).name}
        forceShowTabs={true}
        tabs={tabs}
      >
        {action}
      </Page>
    </AIAgentsHubProvider>
  );
};

export default React.memo(AIAgentsHub);
